import { FC, useState, ChangeEvent } from 'react';
import {
  StyledDialog,
  SubtitleSecondary,
  ReasonTextArea,
  ButtonContainer,
  RejectButton,
  CancelButton,
} from 'src/components/DialogBox/GRNPaymentDialog/ActionPaymentDialog.styles';
import ConfirmHeader from 'src/components/Headers/ConfirmationHeader';
import { CloseIcon } from 'src/components/DialogBox/DialogBox.styles';
import { Box } from '@mui/material';

interface RejectPaymentDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  title?: string;
  subtitle?: string;
  subtitleSecondary?: string;
  placeholder?: string;
  confirmText?: string;
}

const RejectPaymentDialog: FC<RejectPaymentDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title = 'Reject',
  subtitle = 'Are you sure you want to reject this item?',
  subtitleSecondary = 'Once rejected, this action cannot be reversed.',
  placeholder = '',
  confirmText = 'Reject',
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  const handleReasonChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setReason(e.target.value);
    setTouched(true);
  };
  const isReasonEmpty = reason.trim().length === 0;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
    } else {
      setTouched(true);
    }
  };

  const handleClose = () => {
    setReason('');
    setTouched(false);
    onClose();
  };

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      height={subtitleSecondary ? '380px' : '347px'}
    >
      <ConfirmHeader
        iconColor="var(--error)"
        title={title}
        subtitle={subtitle}
        mb={subtitleSecondary ? 1 : 2}
      />
      <CloseIcon
        component="i"
        className="bx bx-x-circle"
        onClick={handleClose}
      />
      {subtitleSecondary && (
        <Box ml={4} display="flex" alignItems="center" mb={1}>
          <SubtitleSecondary>{subtitleSecondary}</SubtitleSecondary>
        </Box>
      )}
      <ReasonTextArea
        placeholder={placeholder}
        value={reason}
        cols={3}
        onChange={handleReasonChange}
        style={{
          borderColor: touched && isReasonEmpty ? 'var(--error)' : undefined,
        }}
      />
      <ButtonContainer>
        <RejectButton onClick={handleConfirm} disabled={isReasonEmpty}>
          {confirmText}
        </RejectButton>
        <CancelButton onClick={handleClose}>Cancel</CancelButton>
      </ButtonContainer>
    </StyledDialog>
  );
};

export default RejectPaymentDialog;
